export const accordianAnimation = {
    variants: {
        open: {
            opacity: 1,
            height: 'auto',
        },
        collapsed: {
            opacity: 0,
            height: 0,
        },
    },
    transition: { type: 'tween', duration: 0.2, ease: [0.4, 0, 0.2, 1] },
    initial: 'collapsed',
    animate: 'open',
    exit: 'collapsed',
};
